import { withOpeningAndClosingBows } from './ceremony'
import type { KataDefinition } from './types'

/**
 * Ju-no-Kata — three kyō sets.
 * Preserve 腮押 and 肩廻 as written by Kodokan.
 */
export const juNoKata: KataDefinition = withOpeningAndClosingBows({
  id: 'ju-no-kata',
  name: 'Ju-no-Kata',
  nameJa: '柔の形',
  theme: {
    from: '#2dd4bf',
    to: '#0f766e',
    text: '#042f2e',
  },
  groups: [
    {
      id: 'dai-ikkyo',
      name: 'Dai-ikkyo',
      nameJa: '第一教',
      techniques: [
        { id: 'ju-tsuki-dashi', name: 'Tsuki-dashi', nameJa: '突出' },
        { id: 'ju-kata-oshi', name: 'Kata-oshi', nameJa: '肩押' },
        { id: 'ju-ryote-dori', name: 'Ryote-dori', nameJa: '両手取' },
        { id: 'ju-kata-mawashi', name: 'Kata-mawashi', nameJa: '肩廻' },
        { id: 'ju-ago-oshi', name: 'Ago-oshi', nameJa: '腮押' },
      ],
    },
    {
      id: 'dai-nikyo',
      name: 'Dai-nikyo',
      nameJa: '第二教',
      techniques: [
        { id: 'ju-kiri-oroshi', name: 'Kiri-oroshi', nameJa: '切下' },
        { id: 'ju-ryokata-oshi', name: 'Ryo-kata-oshi', nameJa: '両肩押' },
        { id: 'ju-naname-uchi', name: 'Naname-uchi', nameJa: '斜打' },
        { id: 'ju-katate-dori', name: 'Katate-dori', nameJa: '片手取' },
        { id: 'ju-katate-age', name: 'Katate-age', nameJa: '片手挙' },
      ],
    },
    {
      id: 'dai-sankyo',
      name: 'Dai-sankyo',
      nameJa: '第三教',
      techniques: [
        { id: 'ju-obi-tori', name: 'Obi-tori', nameJa: '帯取' },
        { id: 'ju-mune-oshi', name: 'Mune-oshi', nameJa: '胸押' },
        { id: 'ju-tsuki-age', name: 'Tsuki-age', nameJa: '突上' },
        { id: 'ju-uchi-oroshi', name: 'Uchi-oroshi', nameJa: '打下' },
        { id: 'ju-ryogan-tsuki', name: 'Ryo-gan-tsuki', nameJa: '両眼突' },
      ],
    },
  ],
})
